// extracted by mini-css-extract-plugin
export default {"gap_10":"UploadCartoonsItem_gap_10__GMkHL","gap_5":"UploadCartoonsItem_gap_5__RTywN"};